import {
  ProviderContext,
  SnackbarKey,
  SnackbarMessage,
  SnackbarProvider,
  useSnackbar,
  VariantType,
} from 'notistack';
import { ReactNode } from 'react';

import { CustomSnackbar } from './CustomSnackbar';

let useSnackbarRef: ProviderContext;
let errorSnackBarId: SnackbarKey[] = [];
let infoSnackbarId: SnackbarKey | null = null;
const SnackbarUtils: React.FC = () => {
  useSnackbarRef = useSnackbar();

  return null;
};

export const SnackbarUtilsProvider = (props: { children: ReactNode }) => {
  return (
    <SnackbarProvider
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      Components={{
        default: CustomSnackbar,
        error: CustomSnackbar,
        info: CustomSnackbar,
        success: CustomSnackbar,
        warning: CustomSnackbar,
      }}>
      <SnackbarUtils />

      {props.children}
    </SnackbarProvider>
  );
};

export const Snackbar = {
  success(msg: SnackbarMessage) {
    if (infoSnackbarId) {
      useSnackbarRef.closeSnackbar(infoSnackbarId);
      infoSnackbarId = null;
    }
    this.snackbar(msg, 'success', 3 * 1000);
  },
  warning(msg: SnackbarMessage) {
    this.snackbar(msg, 'warning', 3 * 1000);
  },
  info(msg: SnackbarMessage) {
    infoSnackbarId = useSnackbarRef.enqueueSnackbar(msg, {
      variant: 'info',
      autoHideDuration: null,
    });
  },
  error(msg: SnackbarMessage) {
    if (infoSnackbarId) {
      useSnackbarRef.closeSnackbar(infoSnackbarId);
      infoSnackbarId = null;
    }
    this.snackbar(msg, 'error', 3 * 1000);
  },
  getErrorSnackbarId() {
    return errorSnackBarId;
  },
  snackbar(
    msg: SnackbarMessage,
    variant: VariantType = 'default',
    duration: number | null = null,
  ) {
    useSnackbarRef.enqueueSnackbar(msg, {
      variant,
      autoHideDuration: duration,
    });
  },
};
